import { AllSelectOption, BooleanSelectOption } from '@storage/app/models'
import { AllValue } from '@storage/components/form-controls/constants'
import { hasValue } from '@storage/utils/has-value'

export const mapBooleanToBooleanSelectOption = (
  value?: boolean | null,
): BooleanSelectOption | AllSelectOption => {
  return hasValue(value) ? (value ? BooleanSelectOption.True : BooleanSelectOption.False) : AllValue
}
